import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Store, Action } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { Subscription } from "rxjs/Subscription";
import { UserStore } from "@store/user";
import { Contact } from "@models/contact";
import { Enquiry } from "@models/enquiry";
import { EnquiriesStore } from "@store/enquiries";
import {
  UPDATE_ENQUIRY,
  CREATE_ENQUIRY,
  ENQUIRY_ACTIVE_INCREMENT_STEP,
  ENQUIRY_ACTIVE_DECREMENT_STEP
} from "@reducers/enquiries";
import { Actions } from "@ngrx/effects";

@Component({
  selector: 'online-enrolment-view',
  templateUrl: './online-enrolment-view.pug',
})
export class OnlineEnrolmentViewComponent implements OnInit, OnDestroy {

  public currentUserContact: Contact
  public enquiry: Enquiry

  private userSubscription: Subscription
  private enquiriesSubscription: Subscription
  private actionsSubscription: Subscription

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private actions: Actions,
  ) {}

  ngOnInit() {
    this.userSubscription =
      this.store.select("userReducer").subscribe((s: UserStore) => {
        this.currentUserContact = s.currentUserContact
      })

    this.enquiriesSubscription =
      this.store.select("enquiriesReducer").subscribe((s: EnquiriesStore) => {
        this.enquiry = s.activeEnquiry
        this.setupInitialState()
      })

    this.actionsSubscription =
      this.actions
        .ofType(ENQUIRY_ACTIVE_INCREMENT_STEP, ENQUIRY_ACTIVE_DECREMENT_STEP)
        .subscribe((a: Action) => {
          this.saveEnquiry()
        })
  }

  setupInitialState() {
    if (this.enquiry.guid) {
      this.router.navigate(
        ['/online-enrolment'],
        { queryParams: { guid: this.enquiry.guid } })
    }
  }

  saveEnquiry() {
    if (!this.enquiry.guid) {
      this.enquiry.guid = this.generateGuid()

      this.router.navigate(
        ['/online-enrolment'],
        { queryParams: { guid: this.enquiry.guid } })

      this.store.dispatch({ type: CREATE_ENQUIRY, payload: this.enquiry })
    }
    else {
      this.store.dispatch({ type: UPDATE_ENQUIRY, payload: this.enquiry })
    }
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe()
    this.enquiriesSubscription.unsubscribe()
    this.actionsSubscription.unsubscribe()
  }

  private s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  private generateGuid(): string {
    return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
      this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/online-enrolment-view.ts